import * as React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { generatePrivateRoutes } from "./config/MyRoute";
import Layout from "Templates/Layout";
import Login from "Templates/login/login";

const routes = (rts) =>
  generatePrivateRoutes([
    {
      path: "/",
      import: "pages",
    },
    {
      path: "/login",
      element: <Login />,
    },
    ...rts,
  ]);

export const RootRouter = (route) =>
  createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<Layout />}>
        {routes(route)}
      </Route>
    )
  );
